export class UserAuthority {
  constructor(
    public documentEditable: boolean,
    public documentDeletable: boolean,
    public documentPrintable: boolean,
    public formatEditable: boolean,
    public hierarchiesEditable: boolean,
    public administratorDepartmentIds: string[],
    public isOrderable: boolean,
    public commonItemEditable: boolean,
    public maintenanceAccessible: boolean) {
  }
}
